import script from "./ProfilRisque.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilRisque.vue?vue&type=script&setup=true&lang=js"

import "./ProfilRisque.vue?vue&type=style&index=0&id=aabb9cc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aabb9cc4"]])

export default __exports__